import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { State } from "./types";
import { discussion } from "@planzone/dto";

function handleRequest(
  state: State,
  { subject }: Boundaries["retrieveDiscussion"]["request"],
): State {
  const hasSearchedGroups = state.find((result) => result.subject === subject);

  return hasSearchedGroups
    ? state.map((result) =>
        result.subject === subject
          ? { ...result, request: setRequestStateToPending() }
          : result,
      )
    : [
        ...state,
        {
          subject,
          discussion: { ...discussion, uuid: "" },
          request: setRequestStateToPending(),
          page: 0,
          canLoadMore: true,
        },
      ];
}

export { handleRequest };
